// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__tjWhT","colMaxWidth":"Table_colMaxWidth__jkeBU"};